/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TimesIcon, ZoomIcon } from 'shared/components/Icons';
import Input from 'shared/components/Input';
import CheckBox from 'shared/components/CheckBox';
import useDebounce from 'shared/hooks/useDebounce';
import { getError, isEmail, openEmailClient } from 'utils/appHelpers';
import { useAlert } from 'react-alert';
import { API, graphqlOperation } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { searchUsers } from 'graphql/user/queries';
import useOutsideClick from 'shared/hooks/useOutsideClick';
import Button from 'shared/components/Button';
import ManageModal from 'shared/components/modals/ManageModal';
import UserWithAvatar from 'shared/components/UserWithAvatar';
import Loading from 'shared/components/Loading';
import { URLS } from 'configs';

// const userPermission = [{ name: 'access_can_view', type: 1 }, { name: 'access_can_edit', type: 2 }];

const ProjectPeopleSelection = ({
  idEditMode,
  setFriendSelection,
  onSaveSubmit,
  selectedUsers,
  initialUsersIds = [],
}) => {
  const account = useSelector(state => state.account);
  const alert = useAlert();
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [dropMenuOpened, setDropMenuOpened] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [selectedUsersIds, setSelectedUsersIds] = useState([...initialUsersIds]);
  const [selUsers, setSelUsers] = useState(selectedUsers || []);
  const [search, setSearch] = useState();
  const debSearch = useDebounce(search, 300);
  const peopleSearchRef = useRef();
  useOutsideClick([peopleSearchRef], () => setDropMenuOpened(false));

  const searchUsersData = async val => {
    try {
      setFetching(true);
      const body = {
        and: [
          { id: { ne: account.id } },
          { or: [{ email: { matchPhrasePrefix: search } }, { name: { matchPhrase: search } }] },
        ],
      };
      const usersSearch = await API.graphql(graphqlOperation(searchUsers, { filter: body }));
      setUsers(usersSearch.data.searchUsers.items);
      setDropMenuOpened(true);
    } catch (err) {
      alert.error(getError(err));
    } finally {
      setFetching(false);
    }
  };

  const onClearSearch = () => {
    setSearch();
    setDropMenuOpened(false);
    setUsers([]);
  };

  const onToggleFriend = id => {
    const tempData = [...selectedUsersIds];
    if (tempData.includes(id)) {
      tempData.splice(tempData.indexOf(id), 1);
    } else {
      tempData.push(id);
    }
    setSelectedUsersIds(tempData);
  };

  // const changeUserPermission = (id, type) => {
  //   const tempData = { ...selectedUsersIds };
  //   tempData[id] = type;
  //   setSelectedUsersIds(tempData);
  // };

  const onFocus = () => {
    if (users?.length) setDropMenuOpened(true);
  };

  const onAddUser = user => {
    const tempUsers = [...selUsers];
    const userAlreadyOnList = tempUsers.find(i => i.id === user.id);
    if (!userAlreadyOnList) {
      tempUsers.unshift(user);
      setSelUsers(tempUsers);
    }
    setSelectedUsersIds([...selectedUsersIds, user.id]);
  };

  const onRemoveUser = user => {
    // const tempUsers = [...selUsers].filter(i => i.id !== user.id);
    // setSelUsers(tempUsers);
    const tempData = [...selectedUsersIds];
    tempData.splice(tempData.indexOf(user.id), 1);
    setSelectedUsersIds(tempData);
  };

  const onFormSubmit = () => {
    const activeUsers = [...selUsers].filter(i => selectedUsersIds.includes(i.id));
    onSaveSubmit(activeUsers, selectedUsersIds);
    setFriendSelection(false);
  };

  const onUserInvite = user => {
    const subject = `Discover ${account.name}'s Favorites on Likiee! 🌟`;
    const body = `Discover ${account.name}'s Favorites on Likiee! 🌟 \n\nHey there\n\n${
      account.name
    }'s curated a special project on Likiee, filled with his top picks and personal likings. Ever wondered what catches his eye online?\n\nJoin Likiee for free and discover a world of organized shopping, innovative project collaborations, and endless inspiration! 🌟\n\nClick here to join and see what ${
      account.name
    } has in store for you!\n${URLS.CONTACT}\n\n Together, let's make e-commerce wishes come true. See you on Likiee!`;
    openEmailClient(user.email, subject, body);
  };
  useEffect(() => {
    if (debSearch) searchUsersData(debSearch);
    else setUsers([]);
  }, [debSearch]);
  const inviteUser = { id: Math.random(), name: search, isInvite: true, email: search };
  const isInviteUserAlreadyInList = users.find(i => i.email === inviteUser.email);
  const isSearchEmail = isEmail(search);
  const showingUsers = isSearchEmail && !isInviteUserAlreadyInList ? [...users, inviteUser] : users;
  const openUserList = !!showingUsers?.length && (dropMenuOpened || isSearchEmail);
  return (
    <ManageModal
      title={t('title_some_firends')}
      sumbitButton={t('btn_save_changes')}
      onCloseModal={() => setFriendSelection(false)}
      onSubmit={onFormSubmit}
      onBackClick={() => setFriendSelection(false)}
      className='min-h-500'
      classNameForm='flex-fill d-flex flex-column justify-content-between'
    >
      <div>
        <div
          ref={peopleSearchRef}
          className={`d-flex align-items-center border justify-content-between rounded-8 px-8 mb-15 people-search ${
            openUserList ? 'opened' : ''
          }`}
        >
          <span className='position-absolute'>
            <ZoomIcon className='svg-gray' />
          </span>
          <Input
            type='text'
            className='mb-0 w-100 overflow-hidden'
            inputClassName='border-0 ml-10'
            name='id'
            value={search}
            onFocus={onFocus}
            placeholder={t('ph_email_or_name')}
            onChange={e => setSearch(e.target.value)}
          />
          {dropMenuOpened && search && !fetching && (
            <span className='position-absolute r-0 mr-10 cursor-pointer' onClick={onClearSearch}>
              <TimesIcon />
            </span>
          )}
          {search && fetching && (
            <span className='position-absolute r-0 mr-10 cursor-pointer'>
              <Loading classSpinner='spinner-border-sm' />
            </span>
          )}
          {openUserList && (
            <div className='people-drop-menu p-10 w-100 bg-white'>
              {showingUsers.map((user, i) => {
                const isLast = showingUsers.length - 1 === i;
                const isInvite = user.isInvite;
                const isAdded = selectedUsersIds.includes(user.id);
                return (
                  <div
                    key={user.id}
                    className={`d-flex align-items-center justify-content-between ${isLast ? '' : 'mb-7'}`}
                  >
                    <UserWithAvatar user={user} />
                    <Button
                      type='button'
                      className='btn-sm py-4 px-11 btn-outline-primary fw-500'
                      onClick={
                        isInvite
                          ? onUserInvite.bind(null, user)
                          : isAdded
                          ? onRemoveUser.bind(null, user)
                          : onAddUser.bind(null, user)
                      }
                    >
                      {isInvite ? t('btn_invite') : isAdded ? t('btn_remove') : t('btn_add')}
                    </Button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {!!selUsers?.length && <p className='mb-5 mt-5 text-dark fw-500'>{t('friend_list_title')}</p>}
        <div className='scroll-y-content max-h-250'>
          {selUsers.map((item, index) => {
            const checked = selectedUsersIds.includes(item.id);
            // TODO: after implement view/edit access
            // const accessItem = selectedUsersIds[item.id] && userPermission.find(i => i.type === selectedUsersIds[item.id]);
            if (idEditMode && !checked) return null;
            return (
              <div className='d-flex align-items-center justify-content-between mb-4 mb-md-7' key={index}>
                <CheckBox
                  hideCheckbox={idEditMode}
                  className='mb-0'
                  label={<UserWithAvatar user={item} />}
                  id={`check${item.id}`}
                  name={`check${item.id}`}
                  checked={checked}
                  onChange={onToggleFriend.bind(null, item.id)}
                />
                {/* TODO: after implement view/edit access */}
                {/* {!!accessItem && (
                <Dropdown title={t(accessItem.name)} size='small'>
                  {userPermission.map((access, i) => {
                    if (accessItem && accessItem.type === access.type) return null;
                    return (
                      <Dropdown.Item onClick={changeUserPermission.bind(null, item.id, access.type)} key={i}>
                        {t(access.name)}
                      </Dropdown.Item>
                    );
                  })}
                  {idEditMode && (
                    <Dropdown.Item onClick={onToggleFriend.bind(null, item.id)}>{t('btn_delete')}</Dropdown.Item>
                  )}
                </Dropdown>
              )} */}
              </div>
            );
          })}
        </div>
      </div>
    </ManageModal>
  );
};
export default ProjectPeopleSelection;
